import { IGetFuncionarioAssinaturaDropDownUseCase } from "../../../presentation/useCases/read/get_funcionario_assinatura_drop_down_use_case";
import { FuncionarioAssinaturaDropDown } from "../../models/funcionario_assinatura_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetFuncionarioAssinaturaDropDownUseCase
 */

export class GetFuncionarioAssinaturaDropDownUseCase implements IGetFuncionarioAssinaturaDropDownUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getFuncionarioAssinaturaDropDown(): Promise<FuncionarioAssinaturaDropDown[]> {
    return await this.repository.getFuncionarioAssinaturaDropDown();
  }
}
